import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { OptionType } from './stores.service';

export interface NavigateActions {
  currentAction: string;
  nextAction: string;
  currentType: string;
  nextType: string;
}
@Injectable({
  providedIn: 'root'
})
export class UrlService {
  private previousUrl: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public previousUrl$: Observable<string> = this.previousUrl.asObservable();

  public lastActionOpened: BehaviorSubject<NavigateActions> = new BehaviorSubject<any>({});
  public lastActionOpened$: Observable<NavigateActions> = this.lastActionOpened.asObservable();
  private selectedOptionSubject = new BehaviorSubject<OptionType | null>(null);
  selectedFollowUpAction$: Observable<any> = this.selectedOptionSubject.asObservable();
  
 
  constructor() { }

  setPreviousUrl(previousUrl: string) {
    this.previousUrl.next(previousUrl);
  }

  setLastActionOpened(lastActionOpened: NavigateActions) {
    console.log("updated",lastActionOpened)
    this.lastActionOpened.next(lastActionOpened);
    console.log(this.lastActionOpened)
  }
  setSelectedOption(option: string) {
    console.log('here i am changed ', option)
    this.selectedOptionSubject.next(option);
  }
  getState(){

  }

  public currentPathSubject = new BehaviorSubject<string>('');
      currentPathSubject$ = this.currentPathSubject.asObservable();
     

  setPath(option: string) {
    this.currentPathSubject.next(option);
  }

}
